import React, { useMemo } from 'react';

import { useSettings } from '@atlas/core';
import { Label } from '@atlas/ui';

import { BASE_PATH } from 'common/constants';

export const ThirdStep = () => {
  const { theme } = useSettings();

  const imgSrc = useMemo(
    () => `${BASE_PATH}/static/assets/images/add-to-home-screen/step-3-${theme || 'dark'}.svg`,
    [theme],
  );

  return (
    <div className="add-to-home-screen-ios-popup__step">
      <div className="add-to-home-screen-ios-popup__step-title title-big-bold-text">
        <Label message="add_to_home_screen_popup_step" />3
      </div>
      <Label className="sub-title-400-text" message="add_to_home_screen_popup_step_3_text" />
      <div className="add-to-home-screen-ios-popup__step-image-wrapper">
        <Label
          className="add-to-home-screen-ios-popup__step-image-wrapper-step-3-text-1"
          message="safari_cancel"
        />
        <Label
          className="add-to-home-screen-ios-popup__step-image-wrapper-step-3-text-2"
          message="safari_add_to_home_screen"
        />
        <Label
          className="add-to-home-screen-ios-popup__step-image-wrapper-step-3-text-3"
          message="safari_add"
        />
        <img alt="pwa-popup" className="add-to-home-screen-ios-popup__step-image" src={imgSrc} />
      </div>
    </div>
  );
};
